import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CircularProgress from "@mui/material/CircularProgress";
import FollowTheSignsIcon from "@mui/icons-material/FollowTheSigns";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";

import { useStore } from "../../context/StoreContext";
import { api } from "../../hooks/apiClient";
import { Box, Button } from "@mui/material";
import { useSnackbar } from "notistack";
import LoadingButton from "@mui/lab/LoadingButton";
const LaamProducts = ({ authToken }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { selectedStore, isStoreSelected } = useStore();
  const store = isStoreSelected && selectedStore.id;
  const [data, setData] = useState([]);
  const [value, setValue] = useState();
  const [newBarcode, setNewBarcode] = useState();
  const [newSku, setNewSku] = useState();
  const [filteredResults, setFilteredResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(true);
  const getProducts = (status) => {
    setLoading(true);

    const params = new URLSearchParams({
      param: status,
    }).toString();

    api
      .get(`products/all/forstore/${store}?${params}`, {
        headers: {
          token: authToken,
        },
      })
      .then((response) => {
        const productsWithTotalQuantity = response.data.map((product) => ({
          ...product,
          totalQuantity: product.variants.reduce(
            (acc, variant) => acc + variant.inventory_quantity,
            0,
          ),
        }));
        setData(productsWithTotalQuantity);

        sessionStorage.setItem(
          "products",
          JSON.stringify(productsWithTotalQuantity),
        );
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };
  const searchBarcodes = (barcode, sku) => {
    if (barcode) {
      setBtnLoading(true);
      const result = data.flatMap((product) =>
        product.variants.filter((variant) => variant.laam_barcode === barcode),
      );

      if (result.length > 0) {
        const id = result[0].product_id;
        const existing = data.find((item) => item.id === id);
        const alreadyScanned = filteredResults.find(
          (item) => item.laam_barcode === barcode,
        );
        if (alreadyScanned) {
          setFilteredResults((prevResults) =>
            prevResults.map((item) =>
              item.laam_barcode === barcode
                ? {
                    ...item,
                    new_quantity: item.new_quantity + 1,
                    product_title: existing.laam_title,
                  } // Increment the quantity
                : item,
            ),
          );
        } else {
          setFilteredResults((prevResults) => [
            ...prevResults,
            {
              ...result[0],
              new_quantity: 1,
              product_title: existing.laam_title,
            },
          ]);
        }
        setBtnLoading(false);
      } else {
        alert("No Data found...");
      }
      setBtnLoading(false);
      setNewBarcode("");
      return;
    } else if (sku) {
      alert(sku);
      setNewSku("");
    }
  };

  useEffect(() => {
    // console.log(filteredResults)
    if (!isStoreSelected) {
      setData([]);
      sessionStorage.removeItem("products");
    }
    const cached = sessionStorage.getItem("products");
    if (cached) {
      setData(JSON.parse(cached));
    }
  }, []);

  const getLaamProducts = (status) => {
    setLoading(true);

    const params = new URLSearchParams({
      param: status,
    }).toString();

    api
      .get(`products/laam/bystore/${store}?${params}`, {
        headers: {
          token: authToken,
        },
      })
      .then((response) => {
        const productsWithTotalQuantity = response.data.map((product) => ({
          ...product,
          totalQuantity: product.variants.reduce(
            (acc, variant) => acc + variant.inventory_quantity,
            0,
          ),
        }));

        setData(productsWithTotalQuantity);
        sessionStorage.setItem(
          "products",
          JSON.stringify(productsWithTotalQuantity),
        );
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  const columns = [
    {
      field: "image_src", // You can use a field that represents the image URL
      headerName: "Image",
      width: 70,
      renderCell: (params) => (
        <img
          src={params.value} // Assuming params.value contains the image URL
          alt="Product Image"
          style={{ width: 50, height: 50 }}
        />
      ),
    },
    { field: "title", headerName: "Title", width: 500 },
    { field: "id", headerName: "Product ID", width: 150 },
    { field: "status", headerName: "Status", width: 100 },
    { field: "totalQuantity", headerName: "Inventory", width: 150 },
    {
      field: "laam_sync",
      headerName: "Laam Status",
      width: 250,
      renderCell: (params) => (
        <>
          {params.row.laam_sync && (
            <span
              type="button"
              className="btn btn-sm btn-warning me-1 mb-1"
              onClick={() => console.log(`Button clicked for value`)}
            >
              Laam
            </span>
          )}
        </>
      ),
    },
  ];
  const filteredResultscolumns = [
    { field: "product_title", headerName: "Title", width: 400 },
    { field: "product_id", headerName: "PID", width: 200 },
    { field: "title", headerName: "Size", width: 150 },
    { field: "new_quantity", headerName: "QTY", width: 150 },
    { field: "price", headerName: "Price", width: 150 },
    { field: "laam_sku", headerName: "Laam Sku", width: 200 },
    { field: "laam_barcode", headerName: "Laam Barcode", width: 200 },
  ];

  const handleRowClick = (params) => {
    const { row } = params;
    const { id } = row;

    // window.open(`/laam/product/${id}`, "_blank");
    navigate(`/laam/products/${id}`, { replace: false });
  };

  const postFilteredData = async () => {
    if (filteredResults.length == 0) {
      return;
    }

    try {
      const response = await api.post(`orders/return/laam/bystore/${store}`, {
        variants: filteredResults,
      });

      enqueueSnackbar("Added in the order go next...", {
        variant: "success",
      });
    } catch (error) {
      console.error("Error fetching product data:", error);

      enqueueSnackbar("not added in the order empty...", {
        variant: "error",
      });
    }
  };

  const handleTabs = (event, newValue) => {
    if (newValue == "2") {
      getLaamProducts("all");
    } else if (newValue == "0") {
      getProducts("all");
    } else {
      getProducts("active");
    }

    setValue(newValue);
  };

  if (loading) {
    return (
      <div>
        <CircularProgress />
      </div>
    );
  }
  const calculateTotal = () => {
    return filteredResults.reduce(
      (total, item) => total + item.new_quantity,
      0,
    );
  };

  return (
    <div className="mt-2">
      <div className=" shadow p-2 mb-3 bg-body rounded">
        <div className="d-flex justify-content-between">
          <div className="">
            <div className=" d-flex flex_wrap justify-content-center mb-2">
              <div className="mt-3 ms-5 me-5">
                <FollowTheSignsIcon />
              </div>
              <Tabs value={value} onChange={handleTabs} centered>
                <Tab label={"Active"} value={"1"} />
                <Tab label={"All"} value={"0"} />
                <Tab label="Laam" value={"2"} />
              </Tabs>
            </div>
          </div>
          <Box display="flex" alignItems="center" gap={1} p={1}>
            <input
              type="text"
              placeholder="Laam SKU"
              className="form-control form-control-sm border border-success"
              value={newSku || ""}
              onChange={(e) => setNewSku(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  searchBarcodes("", e.target.value);
                }
              }}
            />
            <input
              placeholder="Laam Barcode"
              type="number"
              className="form-control form-control-sm border border-danger"
              value={newBarcode || ""}
              onChange={(e) => setNewBarcode(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  searchBarcodes(e.target.value, "");
                }
              }}
            />
          </Box>
        </div>
      </div>
      {filteredResults && filteredResults.length > 0 ? (
        <div style={{ height: 1000, width: "100%" }}>
          <span>
            <LoadingButton
              loading={btnLoading}
              loadingPosition="start"
              onClick={postFilteredData}
            >
              Hi Post Me
            </LoadingButton>
          </span>
          <DataGrid
            rows={filteredResults}
            rowHeight={25}
            columns={filteredResultscolumns}
            pageSize={5}
            getRowId={(row) => row.id}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </div>
      ) : (
        <>
          {" "}
          {data && data.length > 0 ? (
            <div style={{ height: 1000, width: "100%" }}>
              <DataGrid
                rows={data}
                columns={columns}
                pageSize={5}
                getRowId={(row) => row.id}
                onRowClick={handleRowClick}
                // checkboxSelection
                // onRowSelectionModelChange={(ids) => {
                //   const selectedIDs = new Set(ids);
                //   const selectedRows = data.filter((row) =>
                //     selectedIDs.has(row.id)
                //   );
                //   setSelectedRows(selectedRows);
                // }}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
              />
            </div>
          ) : (
            <div>
              <SyncProblemIcon />
              {!isStoreSelected && <p>No Store Selected</p>}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LaamProducts;
